import { render, staticRenderFns } from "./injuredForm.vue?vue&type=template&id=113998c5"
import script from "./injuredForm.vue?vue&type=script&lang=js"
export * from "./injuredForm.vue?vue&type=script&lang=js"
import style0 from "./injuredForm.vue?vue&type=style&index=0&id=113998c5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports